import { FORGE_MASTER_LABEL_PATH } from '../paths';

export type MasterLabelUrlParams = {
  chainId: number;
  designId?: string | null;
  itemNumber?: string | null;
  normalizedBarcode?: string | null;
  cropIds?: string[];
  highlightMode?: 'similar' | 'different' | 'bad_quality';
};

export function itemNumberFromMasterLabelUrl(masterLabelUrl?: string | null): string | null {
  if (!masterLabelUrl) return null;
  try {
    return new URL(masterLabelUrl, window.location.origin).searchParams.get('in');
  } catch {
    const paramsText = masterLabelUrl.split('?')[1];
    if (!paramsText) return null;
    return new URLSearchParams(paramsText).get('in');
  }
}

export function buildMasterLabelUrl({
  chainId,
  designId,
  itemNumber,
  normalizedBarcode,
  cropIds,
  highlightMode,
}: MasterLabelUrlParams): string {
  const params = new URLSearchParams({ chain: String(chainId) });
  if (designId) params.append('d', designId);
  if (itemNumber) params.append('in', itemNumber);
  if (normalizedBarcode) params.append('nb', normalizedBarcode);
  const uniqueCropIds = [
    ...new Set((cropIds ?? []).map((cropId) => cropId.trim()).filter(Boolean)),
  ];
  uniqueCropIds.forEach((cropId) => {
    params.append('c', cropId);
  });
  if (highlightMode && uniqueCropIds.length > 0) params.set('m', highlightMode);
  return `${FORGE_MASTER_LABEL_PATH}?${params.toString()}`;
}

export function normalizeMasterLabelUrl(
  masterLabelUrl: string | null | undefined,
  {
    chainId,
    fallbackItemNumber,
    requireTarget = false,
  }: {
    chainId: number;
    fallbackItemNumber?: string | null;
    requireTarget?: boolean;
  }
): string | null {
  const itemNumber = fallbackItemNumber || itemNumberFromMasterLabelUrl(masterLabelUrl) || null;
  if (!masterLabelUrl && requireTarget && !itemNumber) return null;

  try {
    const url = masterLabelUrl
      ? new URL(masterLabelUrl, window.location.origin)
      : new URL(FORGE_MASTER_LABEL_PATH, window.location.origin);
    url.pathname = FORGE_MASTER_LABEL_PATH;
    url.searchParams.set('chain', String(chainId));
    if (!url.searchParams.get('in') && itemNumber) {
      url.searchParams.set('in', itemNumber);
    }
    return `${url.pathname}${url.search}`;
  } catch {
    if (requireTarget && !itemNumber) return null;
    if (itemNumber) return buildMasterLabelUrl({ chainId, itemNumber });
    return buildMasterLabelUrl({ chainId });
  }
}
